import { useWooCommerceStores } from 'api/ApiHooks/PointsRewardsApiHooks';
import PartialPageSpinner from 'components/PartialPageSpinner';
import usePortalId from 'hooks/portal/usePortalId';
import { POINTSANDREWARD } from 'routes/paths';
import AddStore from '../../AddStore/AddStore';
import ManageCodeForm from './ManageCodeForm';

export default function ManageCodeReward() {
  const portalId = usePortalId();
  const { data } = useWooCommerceStores(Number(portalId), POINTSANDREWARD);
  if (data === undefined) {
    return <PartialPageSpinner />;
  }

  return (
    <div>
      {data.data.isConnected ? (
        <ManageCodeForm storeId={data.data._id} />
      ) : (
        <AddStore />
      )}
    </div>
  );
}
